import styled from '@emotion/styled'

export const Buttons = styled.div`
  width: 400px;
  display: flex;
  justify-content: space-between;
  margin: auto;
`
